import { useState } from "react";
import { accountService } from "@miplatform/api";
import { CONTACT_STATUSES, HTTP_STATUSES } from "@miplatform/constants";
import { createUUID, extractDigits } from "@miplatform/utils";

export const useAccountContactsTabViewModel = ({ accountId, stateManager }) => {
  const [contacts, setContacts] = useState([]);

  const createContactUUID = createUUID();

  const isLoading = stateManager.isBusy();

  const getContacts = () => {
    stateManager.run(async () => {
      const res = await accountService.contacts.getAll({
        sort: "firstName asc",
        filters: { accountId: { type: "guid", value: accountId } },
      });
      if (res.status === HTTP_STATUSES.OK) {
        setContacts(res.data);
      }
    });
  };

  const createContact = (data) => {
    stateManager.abort(createContactUUID);
    return stateManager.run(async () => {
      const response = await accountService.contacts.create({
        data: {
          ...data,
          phone: extractDigits(data.phone),
          status: CONTACT_STATUSES.ACTIVE,
        },
        toastMessageConfig: {
          success: {
            text: `Contact was created successfully.`,
          },
          failure: {
            text: `Failed to create the contact.`,
          },
        },
      });
      return response.status === HTTP_STATUSES.CREATED;
    }, createContactUUID);
  };

  return {
    isLoading,
    getContacts,
    setContacts,
    createContact,
    contacts,
  };
};
